import { ChangeEvent } from 'react'
import { InputAdornment, MenuItem, Radio, TextField } from '@mui/material'

import { FormError } from '../../types'
import { NegotiationType } from './lib'
import { parseToNegotiationType } from './utils'
import { textFieldWhiteBg } from '../../theme/custom-styles'

export const TradeOperation = ({
  title,
  errors,
  disabled,
  placeholder,
  textFieldType,
  optionsValues,
  currencyOperation,
  additionalInfoValue,
  tradeOperationValue,
  valuesOpenAdditionalInfo,
  additionalInfoPlaceholder,
  handleClearTradeOperationValue,
  handleChangeTradeOperationValue,
  handleChangeAdditionalInfoValue
}: {
  title: string
  errors?: FormError
  disabled?: boolean
  placeholder: string
  textFieldType: string
  currencyOperation: string
  additionalInfoValue?: string
  additionalInfoPlaceholder?: string
  handleClearTradeOperationValue?: () => void
  tradeOperationValue?: string | NegotiationType
  valuesOpenAdditionalInfo?: Array<string | NegotiationType>
  optionsValues?: Array<{ value: NegotiationType; text: string }>
  handleChangeAdditionalInfoValue?: (valueToSet: string) => void
  handleChangeTradeOperationValue?: (valueToSet: string | NegotiationType) => void
}) => {
  return (
    <div className="operation-container">
      <div className="operation-title">{title}</div>
      <div
        className="operation-calculation-container"
        style={textFieldType === 'option' ? { alignItems: 'flex-start' } : {}}
      >
        {textFieldType === 'currency' && (
          <>
            <div className="operation-text-field-container">
              <TextField
                fullWidth
                variant="standard"
                disabled={disabled}
                sx={textFieldWhiteBg}
                placeholder={placeholder}
                value={tradeOperationValue ?? ''}
                onBlur={() => handleClearTradeOperationValue?.()}
                onChange={(event) => handleChangeTradeOperationValue?.(event.target.value)}
              />
            </div>
            <div className="operation-currency-data-container">{currencyOperation}</div>
          </>
        )}
        {textFieldType === 'select' && (
          <div className="operation-select-text-field-container">
            <TextField
              select
              fullWidth
              disabled={disabled}
              variant="standard"
              sx={{
                ...textFieldWhiteBg,
                '& .MuiSelect-select span::before': {
                  content: placeholder,
                  opacity: '0.4'
                },
                '& .MuiInput-input': {
                  padding: '4px 16px'
                },
                '& .MuiSelect-select': {
                  height: '2.2em !important',
                  display: 'inline-flex',
                  alignItems: 'center'
                }
              }}
              value={tradeOperationValue ?? ''}
              onChange={(event) => handleChangeTradeOperationValue?.(event.target.value)}
            >
              <MenuItem value="cobre-pexto-v3">COBRE V3</MenuItem>
              <MenuItem value="cobre-pexto">COBRE V2</MenuItem>
              <MenuItem value="monnet">MONNET</MenuItem>
              <MenuItem value="tpaga">TPAGA</MenuItem>
              <MenuItem value="banco-avvillas">BANCO AVVILLAS</MenuItem>
              <MenuItem value="banco-bbva">BANCO BBVA</MenuItem>
            </TextField>
          </div>
        )}
        {textFieldType === 'option' && (
          <>
            {optionsValues?.map((optionValue: { value: NegotiationType; text: string }, index: number) => {
              return (
                <div
                  key={index}
                  style={{ flexDirection: 'column' }}
                  className="operation-text-field-container"
                >
                  <div
                    style={{ width: '100%', cursor: 'pointer' }}
                    className="operation-text-field-container"
                    onClick={() => handleChangeTradeOperationValue?.(optionValue.value)}
                  >
                    <Radio
                      size="small"
                      checked={optionValue.value === (tradeOperationValue as NegotiationType)}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const valueToSet = parseToNegotiationType(String(event.target.value)) as NegotiationType
                        handleChangeTradeOperationValue?.(valueToSet)
                      }}
                      value={optionValue.value || optionsValues[index].value}
                      name="radio-buttons"
                      inputProps={{ 'aria-label': 'PDF' }}
                      sx={{
                        '&.Mui-checked': {
                          color: '#2ed3b7'
                        }
                      }}
                    />
                    <div>{optionValue.text}</div>
                  </div>
                  {valuesOpenAdditionalInfo?.includes(optionValue.value) && optionValue.value === tradeOperationValue && (
                    <div
                      style={{ width: '100%' }}
                      className="operation-text-field-container"
                    >
                      <TextField
                        fullWidth
                        variant="standard"
                        sx={textFieldWhiteBg}
                        value={additionalInfoValue ?? ''}
                        error={!!errors?.additionalInfoValue}
                        placeholder={additionalInfoPlaceholder}
                        helperText={errors?.additionalInfoValue}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>
                        }}
                        onChange={(event) => handleChangeAdditionalInfoValue?.(event.target.value)}
                      />
                    </div>
                  )}
                </div>
              )
            })}
          </>
        )}
      </div>
    </div>
  )
}
